/**
 * Release sürümü — scripts/sync-app-version.js tarafından üretilir.
 * Build: YYYY-MM-DD.HHmmss | Local: "local"
 * Elle düzenlemeyin.
 */
export const APP_VERSION: string = "2026-10-21.205727";
